import vuetify from '@/main';
import Time from '@/modules/timeentries/Time.vue';
angular.module('leanlaw').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  $stateProvider.state('timeentries', {
    url: '/timeentries?new',
    template: require('./views/timeentries.html'),
    controller: 'TimeEntriesCtrl'
  }).state('time', {
    url: '/time?fixedFeeAssignment',
    ...vuetify(Time),
    params: {
      fixedFeeAssignment: {
        value: null,
        squash: true
      }
    }
  }).state('timeentries.matter', {
    track: 'Matter: Create',
    url: '/matter',
    params: {
      clientId: null
    },
    views: {
      edit: {
        template: require('../matters/views/create.html'),
        controller: 'MattersCreateCtrl'
      }
    }
  }).state('timeentries.matter.client', {
    //Client create pop-up
    track: 'Client: Create',
    url: '/client',
    params: {
      popup: true
    },
    views: {
      edit: {
        template: require('../matters/views/client-popup.html')
      },
      //nested view
      'popup@timeentries.matter.client': {
        template: require('../matters/views/client.html'),
        controller: 'ClientEditCtrl'
      }
    }
  });
}]);